import { SignOut } from "@phosphor-icons/react";
import { useAuth } from "react-oidc-context";
import { useMeContext } from "../../api/me";
import Avatar from "../Avatar";
import DropdownMenu from "../DropdownMenu";

const AvatarDropdownMenu = () => {
    const { signoutRedirect } = useAuth();
    const { emailAddress, isLoading, initials } = useMeContext();

    const email = isLoading || !emailAddress ? "Loading..." : emailAddress;

    return (
        <DropdownMenu.Container>
            <DropdownMenu.Trigger>
                {() => <Avatar initials={initials} />}
            </DropdownMenu.Trigger>
            <DropdownMenu.Items>
                <DropdownMenu.Item>
                    <div className="px-4 py-3">{email}</div>
                </DropdownMenu.Item>
                <DropdownMenu.Item>
                    <button
                        className="flex items-center px-4 py-3 gap-3 hover:bg-surface-light-1 transition-colors w-full"
                        onClick={() => signoutRedirect()}
                    >
                        <SignOut size={20} />
                        Logout
                    </button>
                </DropdownMenu.Item>
            </DropdownMenu.Items>
        </DropdownMenu.Container>
    );
};

export default AvatarDropdownMenu;
